export default __webpack_public_path__ + "static/media/fitness3.62f47bc8.PNG";